import styled from "styled-components";
import { responsive } from "../../../../styles/constants.style";

export const GenericAccountHeaderWrapper = styled.div`
  .bottom-button-edit {
    margin: 16px 0px;

    ${responsive.MOBILE`
      width: 100%;
      margin: 0 0 16px 0;
    `}
  }
  .header-container {
    display: flex;
    justify-content: space-between;
  }
`;
